import axios from "@/api/axiosInstance";
import { SaveCatalogProductRequest, SaveCatalogProductResponse } from "./types";

export const createCatalogProduct = async (
  payload: SaveCatalogProductRequest,
): Promise<SaveCatalogProductResponse> => {
  const response = await axios.post<SaveCatalogProductResponse>(
    "/api/private/product-catalog/products",
    payload,
  );
  return response.data;
};
